import React from 'react';
import UserDateInformationContainer from '../../../common/UserDateInformationContainer';
import { isChemicalSafetyExpert } from '../../../../behavior/init/selectors';
import { InputWrapper } from 'react-lib/dist/components-es';
import GridColumnInputWrapper from '../../../common/GridColumnInputWrapper';
import useUser from '@behavior/init/getUserV2';

type Props = {
  values: any;
  setFieldValue: (name: string, value: any) => void;
  initialData: any;
  setValidateOnChange: (arg: boolean) => void;
  disabled: boolean;
  errors: any;
};

const ICheckedCseInformationContainer = ({
  values,
  setFieldValue,
  initialData,
  setValidateOnChange,
  disabled,
  errors,
}: Props) => {
  const { user } = useUser();
  const isCSE = isChemicalSafetyExpert(user);

  function getCheckCseCommentsField() {
    return (
      <GridColumnInputWrapper
        width={16}
        value={values.checkCseComments || ''}
        name="checkCseComments"
        label="inventory.details.page.checked.inf.container.check.cse.comments.input"
        rows={2}
        setFieldValue={setFieldValue}
        disabled={disabled}
        values={values}
        errors={errors}
        render={(props: any) => <InputWrapper {...props} type="textarea" />}
      />
    );
  }

  return isCSE ? (
    <UserDateInformationContainer
      accordionTitle="inventory.details.page.checked.cse.inf.container.title"
      userLabel="inventory.details.page.checked.cse.inf.container.check.user.input"
      userName="checkCseUser"
      dteLabel="inventory.details.page.checked.cse.inf.container.check.dte.input"
      dteName="checkCseDte"
      openDirection="up"
      renderOther={getCheckCseCommentsField}
      setFieldValue={setFieldValue}
      initialData={initialData}
      setValidateOnChange={setValidateOnChange}
      disabled={disabled}
      values={values}
      errors={errors}
    />
  ) : null;
};

export default React.memo(ICheckedCseInformationContainer);
